import React, { useEffect, useState } from "react";
import "./News.css";
import { useSearchParams } from "react-router-dom";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getNews } from "../../../actions/news.action";
import ResponsivePagination from "react-responsive-pagination";
import { Link } from "react-router-dom";
import { Translate } from "../../Translate/Translate";
import i18next from "i18next";
import { formatMonth } from "../../formatMonth";
import moment from "moment";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Preloader from "../../Preloader";
import { API_URI } from "../../../axios";
import PageHeader from "../../page-header/PageHeader";

const News = () => {
  const dispatch = useDispatch();
  const language = i18next.language;

  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = Number(searchParams.get("page")) || 1;
  const itemsPerPage = 20;

  useEffect(() => {
    const offset = (currentPage - 1) * itemsPerPage;
    dispatch(getNews(language, offset));
  }, [language, currentPage]);

  const navigate = useNavigate();

  const news_s = useSelector((state) => state?.news);
  const { t } = useTranslation();

  const { news } = news_s;
  const { results = [], count = 0 } = news;
  const totalPages = Math.ceil(count / itemsPerPage);

  const handle_delete = (text) => {
    if (text.length > 60) {
      return text.substring(0, 60) + "...";
    }
    return text;
  };

  const formatDate = (date) => {
    const month = date.split("T")[0].split("-")[1];
    return `${formatMonth(month, language)} ${moment(date).format(`DD, YYYY`)}`;
  };

  const handlePageChange = (page) => {
    setSearchParams({ page: String(page) });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <title>{`${t("news")} - ${t("Ashgabat_International_Airport")}`}</title>
      </Helmet>
      <div className="news-page">
        <PageHeader
          title={t("news")}
          breadCrumbItems={[
            { label: t("home"), path: "/" },
            { label: t("news"), path: "/news" },
          ]}
        />
        <div className="container">
          {/* <div className="section-title text-center">
                        <h1 className="fw-bold"><Translate title='news' /></h1>
                    </div> */}
          <div className="pt-8 grid mobileS:grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 justify-between items-stretch my-4 gap-y-6 gap-x-2 flex-wrap">
            {results ? (
              results.map((item) => (
                <div
                  key={item.id}
                  className="col wow fadeInUp"
                  style={{ boxShadow: "0px 4px 10px 0px #0000000D" }}
                  data-wow-delay="500ms"
                  onClick={() => navigate(`/news/${item.id}`)}
                >
                  <div className="blog-one__single">
                    <div className="blog-one__img">
                      <img
                        src={`${API_URI}${item.image}`}
                        className="w-full h-[200px] object-contain"
                        alt=""
                      />
                    </div>
                    <div className="blog-one__content  h-[150px]">
                      <ul className="blog-one__meta list-unstyled">
                        <li>
                          <Link
                            style={{ textDecoration: "none" }}
                            to={`/news/${item.id}`}
                          >
                            <div
                              className="d-flex capitalize"
                              style={{
                                alignItems: "start",
                                justifyContent: "center",
                              }}
                            >
                              {" "}
                              <DateRangeIcon />{" "}
                              <p className="ms-2">
                                {formatDate(item.created_at)}
                              </p>
                            </div>
                          </Link>
                        </li>
                      </ul>
                      <Link className="" to={`/news/${item.id}`}>
                        <div className="news__title">{item.title}</div>
                      </Link>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center mx-auto">
                <Preloader />
              </div>
            )}
          </div>
          <div className="mx-auto max-w-80 pb-12">
            {totalPages > 1 && (
              <ResponsivePagination
                total={totalPages}
                current={currentPage}
                onPageChange={handlePageChange}
                className="my-custom-pagination"
              />
            )}
          </div>{" "}
        </div>
      </div>
    </>
  );
};

export default News;
